import React from "react";
import { KtpScanError } from "./OwnerInfo.state";
import { Button } from "src/components";
import { ModalManager, Modal } from "src/components/Modal";
import { useTranslation } from "src/hooks/useTranslation";
import styled from "styled-components";
import { Cross } from "@asphalt-react/iconpack";

const KtpScanErrorEl = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 500px;
  max-width: 100%;
  padding: 40px;
  text-align: center;
  font-family: ${(props) => props.theme.text.fontFamily.normal};
`;

const KtpScanErrorCloseEl = styled.button`
  align-self: flex-end;
  display: flex;
  margin-top: 7px;
  padding: 0;
  border: none;
  background: none;
  color: #2d2e34;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
  }
`;

const KtpScanErrorIconEl = styled.svg`
  margin: 27px 0 20px;
`;

const KtpScanErrorTitleEl = styled.h2`
  margin: 0 0 -12px;
  font-family: ${(props) => props.theme.text.fontFamily.bold};
  font-size: 20px;
  line-height: 30px;
  color: #2d2e34;
`;

const KtpScanErrorMessageEl = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 26px;
  color: #4f515c;
`;

type Props = {
  error?: KtpScanError;
  onClose: () => void;
};

export const KtpScanErrorModal = ({ error, onClose }: Props) => {
  const translate = useTranslation();
  const path = `owner_info.ktp_scan.errors.${error}`;

  return (
    <ModalManager showModal={!!error} onClose={onClose}>
      <Modal
        fitWidth
        style={{
          height: "auto",
          borderRadius: 16,
          boxShadow: "0px 4px 20px rgba(30, 44, 106, 0.1)",
        }}
      >
        <KtpScanErrorEl>
          <KtpScanErrorCloseEl aria-label="close" onClick={onClose}>
            <Cross />
          </KtpScanErrorCloseEl>
          <KtpScanErrorIconEl
            width="86"
            height="86"
            viewBox="0 0 80 80"
            aria-hidden="true"
          >
            <circle cx="40" cy="40" r="40" fill="#EA001F" />
            <path
              d="M28 28l24 24M52 28L28 52"
              stroke="#fff"
              strokeWidth="8"
              strokeLinecap="round"
            />
          </KtpScanErrorIconEl>
          <KtpScanErrorTitleEl>
            {translate(`${path}.title`)}
          </KtpScanErrorTitleEl>
          <KtpScanErrorMessageEl>
            {translate(`${path}.message`)}
          </KtpScanErrorMessageEl>
          <Button onClick={onClose} style={{ width: 280, fontSize: 14 }}>
            {translate("owner_info.ktp_scan.cta_try_again")}
          </Button>
        </KtpScanErrorEl>
      </Modal>
    </ModalManager>
  );
};
